import { Box, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router-dom'

import {
  RelatedList,
  RelatedListItem,
  RelatedSettings as RelatedSettingsContainer,
} from 'components/RelatedSettings'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { CONTAINER_SPACING } from 'providers/material-ui/theme/constants'
import { ROUTES } from 'routes'
import { AdUnitForForm } from '../../GeneralForm/hooks/useGetAdUnit'

type Props = Pick<AdUnitForForm['domain'], 'id'> &
  Pick<
    AdUnitForForm['domain']['domainRefresher'],
    'desktopAdThreshold' | 'desktopRefreshInterval' | 'mobileAdThreshold' | 'mobileRefreshInterval'
  >

export const BasicSettingsDomainRelated = ({
  desktopAdThreshold,
  desktopRefreshInterval,
  id,
  mobileAdThreshold,
  mobileRefreshInterval,
}: Props): JSX.Element => {
  const { t: tc } = useTranslation('common')
  const { t } = useTranslation('features/adUnit', {
    keyPrefix: 'form.refresher.basicSettings.relatedSettings',
  })

  const { workspaceId } = useWorkspaceParam()

  const domainRefresherUrl: string = generatePath(ROUTES.INVENTORY.DOMAIN.EDIT, {
    id,
    tab: 'refresher',
    workspaceId,
  })

  return (
    <RelatedSettingsContainer
      title={t('title')}
      url={domainRefresherUrl}
    >
      <Stack
        direction='row'
        sx={{ gap: CONTAINER_SPACING }}
      >
        <Box>
          <Typography>{tc('device.desktop')}</Typography>
          <RelatedList>
            <RelatedListItem content={t('refreshInterval', { value: desktopRefreshInterval })} />
            <RelatedListItem content={t('adThreshold', { value: desktopAdThreshold })} />
          </RelatedList>
        </Box>

        <Box>
          <Typography>{tc('device.mobile')}</Typography>
          <RelatedList>
            <RelatedListItem content={t('refreshInterval', { value: mobileRefreshInterval })} />
            <RelatedListItem content={t('adThreshold', { value: mobileAdThreshold })} />
          </RelatedList>
        </Box>
      </Stack>
    </RelatedSettingsContainer>
  )
}
